import { Moment } from "moment-timezone";
import { WeeklyScheduleByDateType } from "../api/@types/apiResponseTypes";
import ScheduledSession from "./ScheduledSession";
import ScheduledSessionCollection from "./ScheduledSessionCollection";

const SCHEDULE_DATE_FORMAT = "DD/MM/YYYY";
export class SessionsWeeklySchedule {
  schedule: WeeklyScheduleByDateType<ScheduledSessionCollection>;

  constructor(arg?: WeeklyScheduleByDateType<ScheduledSessionCollection>) {
    this.schedule = arg ?? {};
  }

  addSessionOnDate(session: ScheduledSession) {
    const dateKey = session.startTime
      .format(SCHEDULE_DATE_FORMAT)
      .toLowerCase();
    if (!this.schedule[dateKey]) this.schedule[dateKey] = new ScheduledSessionCollection([]);
    this.schedule[dateKey]!.addSession(session);
  }

  getScheduledSessionsOnDate(date: Moment): ScheduledSessionCollection {
    const sessions = this.schedule[date.format(SCHEDULE_DATE_FORMAT)];
    return sessions ?? new ScheduledSessionCollection([]);
  }
}
